module.exports = __webpack_public_path__ + "img/Background4.fe9a4049.png";